import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { goalsService } from "../../../../../../../motw_core/Services/GoalsService";
import { DailyGoals } from "./DailyGoals";
import { GetActiveDailyGoals } from "./GetActiveDailyGoals";


export async function ResetStartDateAsync(DailyGoals: DailyGoals) {
    try {
        const activeDailyGoals = GetActiveDailyGoals(
            DailyGoals.props.GoalsContainer
        );

        DailyGoals.setState({ isPosting: true });

        for (const checkedGoalName of DailyGoals.state.checkedGoals) {
            const dailyGoal = activeDailyGoals.find(
                (goal) => goal.name === checkedGoalName
            )!;

            await goalsService.ResetGoalStartDateToToday(
                ClientDataProvider,
                dailyGoal
            );
        }
    } finally {
        DailyGoals.setState({ isPosting: false, checkedGoals: [] }, () => Data.Load.AllAsync()
        );
    }
}
